import React, { useCallback } from 'react';
import algoliasearch from 'algoliasearch';
import { Box, VStack, Text } from '@chakra-ui/react';
import { useModule } from '@starberry/components';
import { useState } from 'react';

const searchClient = algoliasearch(
  `${process.env.GATSBY_ALGOLIA_APPLICATION_ID}`,
  `${process.env.GATSBY_ALGOLIA_SEARCH_API_KEY}`
);

const index = searchClient.initIndex(`${process.env.GATSBY_ALGOLIA_INDEX_NAME}`);

const SearchInputBox = ({ label, onChange, defaultValue, name }) => {
  const [hits, setHits] = useState(null);
  const [value, setValue] = useState(defaultValue);
  const handleChange = useCallback(
    (e) => {
      index
        .search(e.target.value, {
          cacheable: true,
          distinct: true,
        })
        .then(({ hits }) => {
          setHits(hits);
        });
      setValue(e.target.value);
      onChange?.(e.target.value);
    },
    [onChange]
  );

  const handleSelected = useCallback(
    (selected) => {
      onChange?.(selected);
      setValue(selected);
      setHits(null);
    },
    [onChange]
  );

  const InputField = useModule('InputField');

  return (
    <VStack width="100%" position="relative">
      <InputField
        onChange={() => handleChange}
        inputProps={{
          autocomplete: 'off',
          name: name,
        }}
        value={value}
        label={label}
      />
      {value !== '' && hits !== null && hits.length > 0 && (
        <VStack
          bg="white"
          position="absolute"
          top="100%"
          zIndex={9999}
          width="100%"
          boxShadow="lg"
          maxHeight="200px"
          overflowY="auto"
          borderColor="#f0f0f0"
          borderWidth={1}
          align="flexStart"
        >
          {hits.map((hit) => {
            return (
              <Box
                _hover={{ bgColor: '#f0f0f0' }}
                py={1.5}
                px={2.5}
                cursor="pointer"
                onClick={() => handleSelected(hit.area || hit.area_address)}
              >
                <Text>{hit.area || hit.area_address}</Text>
              </Box>
            );
          })}
        </VStack>
      )}
    </VStack>
  );
};

export default SearchInputBox;
